export default defineNuxtRouteMiddleware((to, from) => {
  const path = appPath(to.path)
  const fromPath = appPath(from.path)
  if (!isGuestPath(path)) return

  // 게스트 앱 설치 링크. 로그인·핀과 관계없이 스토어로만 보낸다.
  if (path === '/guest/link') return

  const { isLinked, isPinUnlocked } = useGuestAuth()
  const isPin = path === '/guest/pin'
  const fromPin = fromPath === '/guest/pin'
  const isSetup =
    path === '/guest/invite-code' ||
    path === '/guest/permission' ||
    path.startsWith('/guest/permission/') ||
    path === '/guest/accessibility-guide'

  if (!isLinked.value && isPin) {
    return navigateTo('/guest/invite-code', { replace: true })
  }

  if (isLinked.value && !isPin && !fromPin && !isPinUnlocked()) {
    return navigateTo('/guest/pin?mode=unlock', { replace: true })
  }

  if (isLinked.value && isSetup) {
    const isRequiredPermissionGate =
      (path === '/guest/permission' || path === '/guest/accessibility-guide') &&
      String(to.query.mode || '') === 'required'
    if (isRequiredPermissionGate) return
    return navigateTo('/guest', { replace: true })
  }
})
